var map = {
	"./Botticelli.webp": 8499,
	"./Cyberpunk.webp": 5290,
	"./Da Vinci.webp": 9259,
	"./Dali.webp": 1321,
	"./Fantasy.webp": 5009,
	"./Kind of Blue.webp": 7637,
	"./Monet.webp": 3301,
	"./Picasso.webp": 7319,
	"./Rainy.webp": 371,
	"./Shanshui.webp": 5883,
	"./Sketch.webp": 3494,
	"./Snowy.webp": 2276,
	"./Van Gogh.webp": 6027,
	"./Watercolour.webp": 4166
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5813;